import { useTranslator } from "@eo-locale/react";

import {
  Box,
  Heading,
  ListItem,
  OrderedList,
  Text,
  useMediaQuery
} from "@/storybook-components";

const PlacesHelp = () => {
  const { translate } = useTranslator();
  const [isDesktop] = useMediaQuery("(min-width: 768px)");
  const list = [
    isDesktop ? "movePin" : "moveConfirm",
    "createBtn",
    "selectPin"
  ].map((item) => {
    return (
      <ListItem key={item}>
        <Text padding={2} fontSize="sm">
          {translate(`places.placesHelp.${item}`)}
        </Text>
      </ListItem>
    );
  });
  return (
    <Box height={{ lg: "22rem" }} tabIndex={0}>
      <Heading as="h1" pb={8}>
        {translate("places.placesHelp.placePin")}
      </Heading>

      <Box height={{ sm: "40svh", md: "30svh", lg: "30svh" }}>
        <Text pb={2} fontSize="sm">
          {translate("places.placesHelp.contribute")}
        </Text>
        <Box>
          <OrderedList>{list}</OrderedList>
        </Box>
      </Box>
    </Box>
  );
};

export default PlacesHelp;
